import { ActionTypes } from "@/App/constants/actionTypes";
import { DrugTypes } from "@/types";

type SelectDrugAction = {
  type: typeof ActionTypes.ADD_SELECTED_DRUG;
  payload: DrugTypes.DrugResult;
};

export const selectDrugAction = (data: DrugTypes.DrugResult): SelectDrugAction => {
  return {
    type: ActionTypes.ADD_SELECTED_DRUG,
    payload: data,
  };
};

type CurrentSelectedDrugAction = {
  type: typeof ActionTypes.ADD_CURRENT_SELECTED_DRUG;
  payload: Array<DrugTypes.DrugResult>;
};

export const currentSelectedDrugAction = (data: Array<DrugTypes.DrugResult>): CurrentSelectedDrugAction => {
  return {
    type: ActionTypes.ADD_CURRENT_SELECTED_DRUG,
    payload: data,
  };
};

export type DrugSelectActions = SelectDrugAction | CurrentSelectedDrugAction;
